export const ProcessActionsAndFactsEnum = Object.freeze({
    RETTS_FACTBOX: 1,
    LOCAL_FACTBOX: 2,
    RETTS_GENERAL_PROCESS_ACTIONS: 3,
    LOCAL_GENERAL_PROCESS_ACTIONS: 4
});
